module.exports = __webpack_public_path__ + "img/noshow_status.ef48f51f.svg";